import { Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { FOOTER_ITEM } from '../../../constants/props';

const useStyles = makeStyles({
  label: {
    marginTop: '1rem',
    lineHeight: '1.1875rem',
    fontWeight: '700',
  },
  description: {
    lineHeight: '1.1875rem',
    fontWeight: '300',
  },
});

const Item = ({ icon, label, description }) => {
  const classes = useStyles();
  return (
    <Grid item container xs direction="column" alignItems="center">
      {icon}
      <Typography className={classes.label}>{label}</Typography>
      <Typography className={classes.description}>{description}</Typography>
    </Grid>
  );
};

Item.propTypes = {
  FOOTER_ITEM,
};

export default Item;
